import React, { useState } from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from "@nextui-org/react";
import CourseFilterIcon from "../assets/svg/CourseFilterIcon";
import Filters from "../app/[lang]/browsecourses/Filters";
import { SecondaryBtn } from "./molecules";
import { usePathname, useRouter } from "next/navigation";
import { useDictionary } from "../context/dictionaryProvider";
import { trackEvent } from "../lib/engageXClient";

export default function FilterCourses({ className }) {
  const dict = useDictionary();
  const [queryParams, setQueryParams] = useState({});
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const pathname = usePathname();
  const { replace } = useRouter();

  const handleClear = (e) => {
    e.preventDefault();
    setQueryParams({});
    replace(pathname, { scroll: false });
  };

  const applyFilter = (key, value) => {
    const updatedQueryParams = { ...queryParams };

    updatedQueryParams[key] = updatedQueryParams[key] || [];

    if (updatedQueryParams[key].includes(value)) {
      updatedQueryParams[key] = updatedQueryParams[key].filter(
        (val) => val !== value
      );
    } else {
      updatedQueryParams[key] = [...updatedQueryParams[key], value];
    }
    setQueryParams(updatedQueryParams);
  };

  const handleFilter = (onClose) => {
    const params = new URLSearchParams();

    for (const [key, values] of Object.entries(queryParams)) {
      if (Array.isArray(values) && values.length > 0) {
        params.set(key, values.join(","));
      }
    }

    const newUrl = `${pathname}?${params.toString()}`;
    for (const [key, values] of Object.entries(queryParams)) {
      if (Array.isArray(values) && values.length > 0) trackEvent("filter_apply", { filter_type: key, value: values.join(",") });
    }

    onClose();
    replace(newUrl, { scroll: false });
  };

  return (
    <>
      <span onClick={onOpen}>
        <CourseFilterIcon classNames="px-2 py-2 md:py-[17px] md:px-[27px]" />
      </span>
      {isOpen && (
        <Modal
          isOpen={isOpen}
          onOpenChange={onOpenChange}
          hideCloseButton
          placement="top-center"
          size="5xl"
          backdrop="opaque"
        >
          <ModalContent>
            {(onClose) => (
              <>
                <ModalHeader className="flex flex-col gap-1" />
                <ModalBody>
                  <Filters
                    showTabs
                    hideTopClear
                    onClose={onClose}
                    applyFilter={applyFilter}
                    preventDefault
                  />
                </ModalBody>
                <ModalFooter>
                  <div className="w-full justify-start lg:justify-between gap-3 flex">
                    <SecondaryBtn onClick={handleClear}>
                      {dict?.courses?.filters?.clear}
                    </SecondaryBtn>
                    <SecondaryBtn onClick={() => handleFilter(onClose)}>
                      {dict?.courses?.filters?.apply}
                    </SecondaryBtn>
                  </div>
                </ModalFooter>
              </>
            )}
          </ModalContent>
        </Modal>
      )}
    </>
  );
}
